import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/UI/Dialog';
import useMobileLayout from 'Hooks/useMobileLayout';
import DialogContent from './DialogContent';


const styles = () => ({
  paper: {
    width: '100%',
  },
});

const RecategorizeEmailDialog = ({
  classes,
  isOpen,
  closeModal,
  ...rest
}) => {
  const isMobile = useMobileLayout();

  return (
    <Dialog
      classes={classes}
      fullScreen={isMobile}
      onClose={closeModal}
      open={isOpen}
      maxWidth="xs"
    >
      <DialogContent
        closeModal={closeModal}
        {...rest}
      />
    </Dialog>
  );
};

RecategorizeEmailDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default withStyles(styles)(RecategorizeEmailDialog);
